import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Add error handling to lazy imports
const lazyWithRetry = (importFunc: () => Promise<any>) => {
  return lazy(() => {
    return new Promise((resolve, reject) => {
      importFunc()
        .then((module) => resolve(module))
        .catch((error) => {
          console.error('Failed to load module:', error);
          // Retry after a delay
          setTimeout(() => {
            importFunc()
              .then(resolve)
              .catch(reject);
          }, 1000);
        });
    });
  });
};

const HomePage = lazyWithRetry(() => import('../pages/home/page'));
const AboutPage = lazyWithRetry(() => import('../pages/about/page'));
const BookingPage = lazyWithRetry(() => import('../pages/booking/page'));
const PaymentPage = lazyWithRetry(() => import('../pages/payment/page'));
const LegalPage = lazyWithRetry(() => import('../pages/legal/page'));
const PrivacyPage = lazyWithRetry(() => import('../pages/privacy/page'));
const NotFound = lazyWithRetry(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/payment',
    element: <PaymentPage />,
  },
  {
    path: '/legal',
    element: <LegalPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;